// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".b247ae45-b054-4f12-a2bf-17122bec86b4.js";
};